var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.791,
    height: 18.272,
    viewBox: "0 0 21.791 18.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(-.315 -5.555)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_910",
    fill: "#c7c7c7",
    d: "M75.5 17.021l6.91 6.91a2.12 2.12 0 0 1 0 3.083l-6.91 6.91a2.162 2.162 0 0 1-3.119.036 2.26 2.26 0 0 1 .071-3.118l3.118-3.083H63.484a2.1 2.1 0 0 1-1.595-.709 2.406 2.406 0 0 1 .532-3.65 2.271 2.271 0 0 1 1.063-.283h12.083s-3.082-3.083-3.118-3.083a2.145 2.145 0 1 1 3.051-3.013z",
    "data-name": "Path 910",
    transform: "translate(-60.965 -10.779)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.69b80f8ff0220dcf6e68694aab869f7f.svg";
export { ForwardRef as ReactComponent };